
import { useContent } from "@/hooks";
import { defineComponent } from "vue";
import { Container, Section } from "@/components/layout";

export default defineComponent({
  name: "Footer",
  components: { Section, Container },
  setup() {
    const { links } = useContent();

    return { links };
  },
});
